import type { LayerState } from '@vitals/shared';
import type { VitalDef, VitalView } from './vitals.js';
import { boroughDetails, validBoroughSummary } from './boroughDetails.js';

/**
 * Vital selector for the MTA Bus Time layer.
 * Shows "N buses rolling" where N is the active vehicle count.
 * Returns down=true with "—" when the feed is unavailable or the key is unset.
 */
export const busesVital: VitalDef = {
  id: 'buses',
  layerId: 'buses',

  select(s: LayerState | undefined): VitalView {
    const isDown = !s || s.status === 'down' || s.summary == null;

    if (isDown) {
      return {
        value: '—',
        label: 'buses',
        down: true,
        stale: false,
      };
    }

    const summary = s.summary as { count: number };
    const hasBreakdown = validBoroughSummary(summary);

    return {
      value: summary.count.toLocaleString('en-US'),
      label: 'buses',
      down: false,
      stale: s.status === 'stale',
      ...(hasBreakdown && {
        detailTitle: 'Buses by borough',
        details: boroughDetails(summary),
      }),
    };
  },
};
